import api from "@/config/api";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import { AxiosError } from "axios";
import { MESSAGES } from "@/constants";
import { getApiErrorMessage } from "@/shared/lib/api-error";
import type { LoginResponseDTO } from "../types/auth.types";

export class AuthService {
  static async login(
    username: string,
    password: string,
  ): Promise<LoginResponseDTO> {
    try {
      const response = await api.post<LoginResponseDTO>(
        API_ENDPOINTS.AUTH.LOGIN,
        {
          username,
          password,
        },
      );

      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        const status = error.response?.status;
        const fallback =
          status === 400 || status === 401
            ? MESSAGES.ERROR.INVALID
            : "Erro ao fazer login. Tente novamente.";
        throw new Error(getApiErrorMessage(error, fallback));
      }

      throw new Error(
        getApiErrorMessage(error, "Erro inesperado ao fazer login"),
      );
    }
  }
}
